// Supported UI languages. Native names are always shown verbatim in the picker
// (never translated into the active locale) — the convention every consumer app
// follows so users can find their language regardless of the current UI.

export interface LanguageOption {
  code: string;
  /** Endonym — the language's name in its own script. Never translated. */
  nativeName: string;
  rtl?: boolean;
}

export const SUPPORTED_LANGUAGES: readonly LanguageOption[] = [
  { code: 'en', nativeName: 'English' },
  { code: 'zh', nativeName: '中文' },
  { code: 'hi', nativeName: 'हिन्दी' },
  { code: 'es', nativeName: 'Español' },
  { code: 'fr', nativeName: 'Français' },
  { code: 'ar', nativeName: 'العربية', rtl: true },
  { code: 'bn', nativeName: 'বাংলা' },
  { code: 'pt', nativeName: 'Português' },
  { code: 'ru', nativeName: 'Русский' },
  { code: 'id', nativeName: 'Bahasa Indonesia' },
];

export const DEFAULT_LOCALE = 'en';

const RTL_LOCALES = new Set(
  SUPPORTED_LANGUAGES.filter((l) => l.rtl).map((l) => l.code),
);

export function isSupportedLocale(code: unknown): code is string {
  return typeof code === 'string' && SUPPORTED_LANGUAGES.some((l) => l.code === code);
}

export function isRtlLocale(code: string): boolean {
  return RTL_LOCALES.has(code);
}
